// extracted by mini-css-extract-plugin
module.exports = {"bgRelatedPosts":"footer-module--bgRelatedPosts--FZLyD"};